import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

const initialState = {
    status: "",
    message: "",
    bcStatus: "",
    bcMessage: ""
}


export const PimConnection = createAsyncThunk("PimConnection", async (pimData) => {
    try {
        const response = await fetch(`/api/pimConnection`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(pimData)
        })
        if (!response.ok) {
            throw new Error('Failed to fetch Pim connection status');
        }
        return await response.text();
    } catch (error) {
        throw new Error('Failed to fetch Pim connection status', error);
    }
});


export const shopifyConnection = createAsyncThunk("shopifyConnection", async (bcData) => {
    try {
        const response = await fetch(`/api/shopifyConnection`, {
            method: 'POST',
            headers: {
                Accept: "application/json",
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(bcData)
        })
        if (!response.ok) {
            throw new Error('Shopify connection failed');
        }
        return await response.text();
    } catch (error) {
        throw new Error('Shopify connection failed', error);
    }
});

const connectionSlice = createSlice({
    name: "getConnectionStatus",
    initialState,
    extraReducers: (builder) => {
        builder.addCase(PimConnection.pending, (state) => {
            state.status = "PIM loading"
            state.message = "Please wait"
        });
        builder.addCase(PimConnection.fulfilled, (state, action) => {
            if (action.payload == '{"status":"SUCCESS"}') {
                state.status = "success"
                state.message = "PIM connection success"
            } else {
                state.status = "error"
                state.message = "PIM connection failed"
            }
        });
        builder.addCase(PimConnection.rejected, (state) => {
            state.status = "error"
            state.message = "PIM connection failed"
        });
        builder.addCase(shopifyConnection.pending, (state) => {
            state.bcStatus = "BC loading"
            state.bcMessage = "Please wait"
        });
        builder.addCase(shopifyConnection.fulfilled, (state, action) => {
            if (action.payload == '{"status":"SUCCESS"}') {
                state.bcStatus = "success"
                state.bcMessage = "Shopify connection success"
            }else{
                state.bcStatus = "error"
                state.bcMessage = "Shopify connection failed"
            }    
        });
        builder.addCase(shopifyConnection.rejected, (state) => {
            state.bcStatus = "error"
            state.bcMessage = "Shopify connection failed"
        });
    }
})

export default connectionSlice.reducer